/**
 * ReferenceImageUploadSlot — Single slot for reference image upload.
 * Max 50 lines.
 */
import { X, Plus } from 'lucide-react';

interface ReferenceSlot { id: string | null; previewUrl: string | null; }

interface Props {
  slot: ReferenceSlot;
  index: number;
  tag: string;
  onUpload: (index: number, file: File) => void;
  onRemove: (index: number) => void;
  onInsertMention: (tag: string) => void;
}

export function ReferenceImageUploadSlot({ slot, index, tag, onUpload, onRemove, onInsertMention }: Props) {
  return (
    <div className="flex flex-col items-center gap-1">
      <div className="relative w-full aspect-square rounded-lg border border-dashed border-border bg-muted overflow-hidden">
        {slot?.previewUrl ? (
          <>
            <img src={slot.previewUrl} alt={tag} className="w-full h-full object-cover" />
            <button
              type="button"
              onClick={() => onRemove(index)}
              className="absolute top-1 right-1 rounded-full bg-destructive p-0.5"
            >
              <X className="w-3 h-3 text-white" />
            </button>
          </>
        ) : (
          <label className="flex items-center justify-center w-full h-full cursor-pointer">
            <Plus className="w-5 h-5 text-muted-foreground" />
            <input
              type="file"
              accept="image/*"
              className="hidden"
              onChange={e => e.target.files?.[0] && onUpload(index, e.target.files[0])}
            />
          </label>
        )}
      </div>
      <button
        type="button"
        onClick={() => onInsertMention(tag)}
        className="text-xs font-mono text-primary hover:underline"
      >
        {tag}
      </button>
    </div>
  );
}
